import { render, staticRenderFns } from "./StatsGridCard.vue?vue&type=template&id=48f25df4&scoped=true"
import script from "./StatsGridCard.vue?vue&type=script&lang=ts"
export * from "./StatsGridCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f25df4",
  null
  
)

export default component.exports